import { ConnectedPosition } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ScreenUtilsService } from 'core/services';
import { SidenavService } from '../sidenav.service';
import { ToolbarSearchService } from '../toolbar-search/toolbar-search.service';

@Component({
  selector: 'ss-mobile-toolbar',
  templateUrl: './mobile-toolbar.component.html',
  styleUrls: ['./mobile-toolbar.component.css'],
  host: {
    class: 'primary-background flex-row gap-large flex--align-center flex--justify-between padding-standard-right'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileToolbarComponent {

  readonly mobileToolbarTemplateRefSubject = this._sidenavService.mobileToolbarTemplateRefSubject;
  readonly userMenuOpenedSubject = this._sidenavService.userMenuOpenedSubject;
  readonly expandedSubject = this._sidenavService.expandedSubject
  readonly positions: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top',
      panelClass: this._screenUtilsService.isSmallerScreen ? 'centered-panel' : null
    }
  ]

  readonly searchVisibleSubject = this._toolbarSearchService.searchVisibleSubject;
  readonly isSmallerScreenObs = this._screenUtilsService.isSmallerScreenObs;
  readonly versionDisplayObs = this._sidenavService.versionDisplayObs;

  constructor(
    private readonly _sidenavService: SidenavService,
    private readonly _toolbarSearchService: ToolbarSearchService,
    private readonly _screenUtilsService: ScreenUtilsService
  ) {

  }


  toggleExpanded() {
    return this._sidenavService.toggleExpanded();
  }
}
